import { Link } from "react-router-dom";

const MenuPages = () => {
    return (
        <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
                <Link to="/Index" className="nav-item nav-link active">Início</Link>
                <Link to="/Sobre" className="nav-item nav-link">Sobre</Link>
                <Link to="/Equipe" className="nav-item nav-link">Equipe</Link>
                <div className="nav-item dropdown">
                    <div className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Treinamento</div>
                    <div className="dropdown-menu m-0">
                        <Link to="/treinamentos/1" className="dropdown-item">Protocolos</Link>
                        <Link to="/treinamentos/2" className="dropdown-item">Fluxogramas</Link>
                        <Link to="/treinamentos/3" className="dropdown-item">Diretrizes</Link>
                        <Link to="/treinamentos/4" className="dropdown-item">Documentos</Link>
                        <Link to="/treinamentos/5" className="dropdown-item">Treinamentos</Link>
                    </div>
                </div>
                <a href="#footer" className="nav-item nav-link">Contato</a>
                <Link to="/Login" className="nav-item nav-link">Administrativo</Link>
            </div>
        </div>
    )
}

export default MenuPages;